<div class="{{localService.selectedLanguageCode}}"
  *ngIf="localService.languageContent && localService.languageContent.product_config">
  <div *ngIf="isShowLabel">
    <app-label
      [Text]="localService.languageContent.product_config.pricing_details + (isExcluded ? (' - ' + localService.languageContent.product_config.excluded) : '')"
      [IsMandatory]="!isExcluded"></app-label>
  </div>
  <div class="row" *ngIf="businessTaxCategories && businessTaxCategories.length > 0">
    <div class="col-12">
      <ngx-select [disabled]="!isEnableTaxCategory" [items]="businessTaxCategories" [optionValueField]="'key'"
        [optionTextField]="'v1'" [(ngModel)]="selectedBusinessTaxCategoryId" [noAutoComplete]="true"
        (select)="onSelectBusinessTax()"></ngx-select>
    </div>
  </div>
  <div *ngIf="items && items.length > 0">
    <div *ngIf="!isExcluded" class="row banner" style="width: calc(100% - 50px);margin: 25px;">
      <div class="col-12">
        <div class="row">
          <div class="col-12" style="text-align: center;">
            <app-label [Text]="localService.languageContent.product_config.biz_taxes" [IsColonRequired]="false"
              [IsBold]="true" />
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <label style="font-weight: normal; margin-left: 15px;">
              <input type="checkbox" [disabled]="true" [(ngModel)]="isNotConsiderTax" />
              <span class="normal_color">{{localService.languageContent.product_config.not_consider_tax}}</span>
            </label>
          </div>
        </div>
        <div class="row styled_row" *ngFor="let tax of businessTax;">
          <div class="col-6">
            <app-label [Text]="tax.v1" />
          </div>
          <div class="col-6" style="text-align: right;color: slategray;">
            <span class="en">&nbsp;{{tax.v4 == 'discount' ? '-' : '+'}}&nbsp;</span>
            <span>{{tax.v3 ? tax.v3 : '0'}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="row banner" style="width: calc(100% - 50px);margin: 25px;" *ngFor="let item of items; index as i">
      <div class="col-12">
        <div class="row">
          <div class="col-12" style="text-align: center;">
            <app-label [Text]="localService.getText(localService.businessTypes,item.content.v1)"
              [IsColonRequired]="false" [IsBold]="true" />
          </div>
        </div>
        <div class="row styled_row">
          <div class="col-6">
            <app-label
              [Text]="isNotConsiderTax ? localService.languageContent.product_config.price : localService.languageContent.product_config.price_base"
              [IsMandatory]="true" />
          </div>
          <div class="col-6" style="text-align: right; padding-right: 4px;">
            <input autocomplete="off" type="number" class="number"
              (keypress)="localService.isNumberOnly($event,numericConfigDefault)" id="txt_{{i+1}}_1"
              [readonly]="isReadOnly" (keydown)="onNavigate($event,i+1,1)"
              [ngStyle]="{'font-weight': (item.content.v4 || item.content.v4 == '0') ? 'bold' : 'normal'}"
              [ngClass]="item.content.v4 != null && item.content.v4 != '' ? 'en' : ''" [(ngModel)]="item.content.v4"
              placeholder="*{{isNotConsiderTax ? localService.languageContent.product_config.price : localService.languageContent.product_config.price_base}}" />
          </div>
        </div>
        <div *ngIf="!isNotConsiderTax">
          <div *ngFor="let tax of item.requiredTax; index as j">
            <div class="row styled_row" *ngIf="(!isExcluded || tax.v4 == 'discount') && businessTax[j].v3">
              <div class="col-6">
                <app-label [Text]="tax.v1" />
              </div>
              <div class="col-6 right">
                <div *ngIf="!isNotConsiderTax && item.content.v4 && (tax.v3 || businessTax[j].v3)">
                  <span class="en">&nbsp;{{tax.v4 == 'discount' ? '-' : '+'}}&nbsp;</span>
                  <span>{{item.content.v4 | getPercentageValue:((tax.v3 == '0' ? '0' : tax.v3) ||
                    businessTax[j].v3)}}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="row styled_row">
            <div class="col-6">
              <app-label [Text]="localService.languageContent.product_config.price" />
            </div>
            <div class="col-6" style="text-align: right;">
              <span><b>{{onGetPriceIncludeTax(item.content.key,item.content.v1)}}</b></span>
            </div>
          </div>
        </div>
        <div class="row styled_row">
          <div class="col-6">
            <app-label [Text]="localService.languageContent.product_config.min_qty" />
          </div>
          <div class="col-6">
            <input autocomplete="off" type="number" class="number"
              (keypress)="localService.isNumberOnly($event,numericConfigDefault)" id="txt_{{i+1}}_2"
              [readonly]="isReadOnly" (keydown)="onNavigate($event,i+1,2)"
              [ngClass]="item.content.v3 != null && item.content.v3 != '' ? 'en' : ''" [(ngModel)]="item.content.v3"
              title="{{localService.languageContent.product_config.min_qty}}"
              placeholder="{{localService.languageContent.product_config.min_qty}}" />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>